import useRouter from '~/client/hooks/router/useRouter';
import { useForfeitFSRewardMutation } from './graphql/ForfeitFSRewardMutation.generated';

type Args = {
  id: string;
  game: string;
  currency: string;
  inGameCurrency?: string;
};

const useForfeitReward = ({ id, game, currency, inGameCurrency }: Args) => {
  const [forfeitFS] = useForfeitFSRewardMutation();
  const { reload } = useRouter();

  const handleForfeit = async () => {
    const { data } = await forfeitFS({
      variables: { id, currency, game, inGameCurrency },
    });
    if (!data?.rewardsForfeitReward?.errors?.length) {
      reload();
    }
  };

  return { handleForfeit };
};

export default useForfeitReward;
